import React from 'react';

function CardSkill(props) {
    return (
        <div className='card-skill'>
            <div className="card-skill__heading">
                <h6 data-aos="fade-right">{props.title}</h6>
            </div>
            <div className="card-skill__content">
                {/* <ul>
                    {props.list.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </ul> */}
                <div dangerouslySetInnerHTML={{ __html: props.list }}></div>

            </div>
        </div>
    );
}

export default CardSkill;